<template>
    <div class="row">
        <div class="col-md-12">

            <div class="row">
                <div class="col-md-8 col-md-offset-2">
                    <h1 class="text-center" style="margin: 40px 0">
                        Bem-vindo à Suite CRM IBOPE DTM!
                    </h1>
                    <p class="text-center">
                        A partir de agora você tem acesso às nossas ferramentas para gerenciamento de campanhas e Business Intelligence. <br />
                        Aprimore os dados gerados pelo seu cliente e estratégias com comunicações cada vez mais personalizadas, assertivas e com gerenciamento facilitado de 
                        todas as campanhas.
                    </p>
                </div>
            </div>

            <!--<div class="row icones">
                <div class="col-sm-4 col-sm-offset-4">
                    <div class="row">
                        <div class="col-md-6 text-center">
                            <a href="https://ibopedtm.com/#contact" target="_blank">
                                <span class="fa-stack fa-3x">
                                    <i class="fa fa-circle fa-stack-2x"></i>
                                    <i class="fa fa-phone fa-stack-1x fa-inverse"></i>
                                </span>
                                <p>Contato</p>
                            </a>
                        </div>
                        <div class="col-md-6 text-center">
                            <a href="#" @click="startTutorial()">
                                <span class="fa-stack fa-3x">
                                    <i class="fa fa-circle fa-stack-2x"></i>
                                    <i class="fa fa-magic fa-stack-1x fa-inverse"></i>
                                </span>
                                <p>Tutorial</p>
                            </a>
                        </div>
                    </div>
                </div>
            </div>-->
        </div>
    </div>
</template>

<script>
import { getUserFull, setAccessToken, getAccessToken } from '@/auth/auth';

export default {
    name: 'portal',
    data: function() {
        return{
            usuario: ''
        }
    },
    mounted: function(){

        this.$nextTick(() => {

            if(typeof getAccessToken() == 'undefined'){
                var code = this.$route.query.code;
                setAccessToken(code);
            }

            if(typeof getAccessToken() != 'undefined')
                this.$router.push('/')
        });

        var self = this

       /*var intervalo = window.setInterval(function() {
            self.introApp()

            if(self.$cookie.get('acesso') < 2)
                self.startTutorial()
        }, 50);

        window.setTimeout(function() {
            clearInterval(intervalo);
        }, 3000);*/s


        var user = getUserFull()
        this.usuario = user.result.user.name
    },
    methods: {
        introApp: function(){
            document.getElementById('aplicacaoAtual').dataset.step = "1";
            document.getElementById('aplicacaoAtual').dataset.intro = "Clique aqui para ter acessos a todas as nossas ferramentas.";

            document.getElementById('listaProjetos').dataset.step = "2";
            document.getElementById('listaProjetos').dataset.intro = "Aqui, você escolher um dos projetos disponíveis.";

            document.getElementById('headerUsuario').dataset.step = "3";
            document.getElementById('headerUsuario').dataset.intro = "Para se deslogar, é só clicar em sair.";
        },
        startTutorial: function(){
            introJs().start();
        }
    }
}
</script>

<style scoped>
    .tab-content h1{
        margin-bottom:50px;
    }

    .icones{
        margin: 40px 0;
    }

    .nomeUser{
        margin-bottom: 33px;
    }

    .page-header img{
        height:39px;
    }

    p{
        font-size:15px;
        line-height:1.6;
    }

    .alert-info h4{
       font-family: 'Lato', sans-serif;
       font-size: 21px;
    }

    .alert-info{
        margin-top: 35px;
    }

    .alert-info i{
        float: left;
        margin-right:20px;
    }

</style>




// WEBPACK FOOTER //
// src/components/Portal.vue?e9d86af4